module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_okinawa-3602aa91fa7836126166095be66d300d.png";